<template>
  <v-container grid-list-xl>
    <div class="head">
      <div class="title">
      <h2 class="pl-4 mt-4">
        <span>Web</span>
        <span class="blue--text">Portfolio</span>
      </h2>
      </div>
      <div class="date mt-3 d-flex align-center">
        <h3>
        Total Projects 
        </h3>
      <v-chip color="#2196f3" text-color="white" label>
        <h4>
        {{projects.length}}
        </h4>
      </v-chip>
      </div>
    </div>
    <v-layout row justify-center align-center wrap class="mt-4 pt-2">
      <v-dialog
        v-model="project.dialog"
        lazy
        max-width="1000"
        v-for="project in projects"
        :key="project.title"
      >
        <template v-slot:activator="{ on }">
          <v-flex xs12 sm6 md4 lg4 xl4 v-on="on">
            <v-card hover flat color="transparent">
              <v-img
                :src="project.poster"
                :alt="project.title"
                height="230"
                lazy-src="https://unra.go.ug/assets/loaders/loader_2.gif"
              ></v-img>
              <v-card-title primary-title class="justify-center">{{project.title}}</v-card-title>
            </v-card>
          </v-flex>
        </template>
        <v-card v-if="project.dialog">
          <v-img :src="project.poster"></v-img>
          <v-card-text>
            <h3 class="headline mb-0">
              <span>Technology</span>
            </h3>
            <v-chip color="blue" text-color="white">{{project.tech.tech1}}</v-chip>
            <v-chip color="blue" text-color="white">{{project.tech.tech2}}</v-chip>
            <v-chip color="blue" text-color="white">{{project.tech.tech3}}</v-chip>
            <v-chip color="blue" text-color="white" :style="project.techVisible">{{project.tech.tech4}}</v-chip>
          </v-card-text>
          <v-card-actions>
            <v-btn flat large dark color="blue" :href="project.git" target="_blank" :style="project.gitVisible">
              <v-icon left>fab fa-github</v-icon>GitHub
            </v-btn>
            <v-btn large flat dark color="blue" :href="project.demo" target="_blank">
              <v-icon left>fas fa-desktop</v-icon>Demo
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  metaInfo: {
    title: "Web Portfolio",
    titleTemplate: "%s ← Midhun Nair",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content:
          "Midhun Nair's Web Portfolio Vue Vue.js HTML CSS Vuetify Axios JavaScript Web Developer Front-End Frontend Designer App Responsive"
      },
      { charset: "utf-8" },
      { property: "og:title", content: "Midhun Nair" },
      { property: "og:site_name", content: "Midhun Nair" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "http://midhunnair.live" },
      {
        property: "og:image",
        content: "https://cdn.image4.io/mndesigns/f_auto/66aa3e55-542a-4355-acb3-2602e5d55414.png"
      },
      {
        property: "og:description",
        content:
          "Midhun Nair's Web Portfolio Vue Vue.js HTML CSS Vuetify Axios JavaScript Web Developer Front-End Frontend Designer App Responsive"
      }
    ]
  },
  data() {
    return {
      dialog: false,
      projects: [
         {
          dialog: false,
          title: "Megha weds Jayesh",
          demo: "http://meghajayesh.ml/",
          gitVisible: "display:none",
          tech: {
            tech1: "HTML",
            tech2: "CSS",
            tech3: "JavaScript",
            tech4: "Bootstrap"
          },
          poster: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/webPortfolio%2FMegha%20%26%20Jayesh.png?alt=media&token=ef2f00a8-db20-497d-ad34-97f8f96b2e26"
        },
        {
          dialog: false,
          title: "This Site",
          gitVisible: "display:none",
          demo: "https://midhunnair.live/",
          tech: {
            tech1: "HTML",
            tech2: "CSS",
            tech3: "JavaScript",
            tech4: "VUE.js"
          },
          poster: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/webPortfolio%2Fthissitw.png?alt=media&token=95bcd2a4-0ab1-47ad-93fa-821226ecd36b"
        },
        {
          dialog: false,
          title: "MN Designs, My Creative Work Gallery",
          gitVisible: "display:none",
          demo: "https://designs.midhunnair.live/",
          tech: {
            tech1: "HTML",
            tech2: "CSS",
            tech3: "JavaScript",
            tech4: "Bootstrap"
          },
          poster: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/webPortfolio%2Fmndesigns.png?alt=media&token=3bccde29-31c7-4f07-af93-374511f2a7ab"
        },
        {
          dialog: false,
          title: "Amazon Clone",
          git: "https://github.com/itsmidhunnair/amazon-clone",
          demo: "https://itsmidhunnair.github.io/amazon-clone/",
          tech: {
            tech1: "HTML",
            tech2: "CSS",
            tech3: "Javascript",
            tech4: "Bootstrap"
          },
          poster: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/webPortfolio%2Famzon-clone.png?alt=media&token=6e6ac81b-9aa5-4ab4-9811-11efcc8147d0"
        },
        {
          dialog: false,
          title: "Mishra Educational Institute",
          gitVisible: "display:none",
          demo: "https://mishraeducationalinstitute.in/",
          tech: {
            tech1: "HTML",
            tech2: "CSS",
            tech3: "Javascript",
            tech4: "Bootstrap"
          },
          poster: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/webPortfolio%2Fmei.png?alt=media&token=168cbd78-55a0-4cc9-8ee8-c8112c4a76db"
        },
        {
          dialog: false,
          title: "Myntra Clone",
          git: "https://github.com/itsmidhunnair/myntra-clone",
          demo: "https://itsmidhunnair.github.io/myntra-clone/",
          tech: {
            tech1: "HTML",
            tech2: "CSS",
            tech3: "Javascript",
            tech4: "Bootstrap"
          },
          poster: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/webPortfolio%2Fmyntra-clone.png?alt=media&token=bd266913-6734-4a20-8766-3a8ae69dd10f"
        },
        {
          dialog: false,
          title: "Gmail Clone",
          git: "https://github.com/itsmidhunnair/gmail-clone",
          demo: "https://itsmidhunnair.github.io/gmail-clone/",
          techVisible: "display:none",
          tech: {
            tech1: "HTML",
            tech2: "CSS",
            tech3: "Javascript"
          },
          poster: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/webPortfolio%2FGmail-clone.png?alt=media&token=d454e768-8ad8-40a4-9ad1-2b7ef842eec6"
        },
        {
          dialog: false,
          title: "Bookmarking App",
          git: "https://github.com/itsmidhunnair/Bookmarking-App.git",
          demo: "https://itsmidhunnair.github.io/Bookmarking-App/",
          tech: {
            tech1: "HTML",
            tech2: "CSS",
            tech3: "JavaScript",
            tech4: "LocalStorage"
          },
          poster: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/webPortfolio%2Fbookmarkapp.png?alt=media&token=2e0da9b1-5551-43f0-926d-cdf1f1410e43"
        },
        {
          dialog: false,
          title: "Button Game",
          git: "https://github.com/itsmidhunnair/Button-Game.git",
          demo: "https://button-game.pages.dev/",
          techVisible: "display:none",
          tech: {
            tech1: "HTML",
            tech2: "CSS",
            tech3: "JavaScript"
          },
          poster: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/webPortfolio%2FButton%20Game.png?alt=media&token=e9f586eb-8835-4252-8131-1a68ef74d6f2"
        },
        {
          dialog: false,
          title: "Scroll Progress",
          git: "https://github.com/itsmidhunnair/Scroll-Progress.git",
          demo: "https://scroll-progress.pages.dev/",
          techVisible: "display:none",
          tech: {
            tech1: "HTML",
            tech2: "CSS",
            tech3: "JavaScript"
          },
          poster: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/webPortfolio%2FScrolling%20Progress.png?alt=media&token=cbde1e30-7d13-4c2c-9658-f3f22c851576"
        },
        {
          dialog: false,
          title: "StopWatch",
          git: "https://github.com/itsmidhunnair/Stopwatch.git",
          demo: "https://stopwatch.pages.dev/",
          techVisible: "display:none",
          tech: {
            tech1: "HTML",
            tech2: "CSS",
            tech3: "JavaScript"
          },
          poster: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/webPortfolio%2FStopWatch.png?alt=media&token=32201b17-c03a-45ef-9217-a83600254f8d"
        },
        {
          dialog: false,
          title: "FAQs Dropdown Sample",
          git: "https://github.com/itsmidhunnair/FAQs-Dropdown.git",
          demo: "https://faqs-dropdown.pages.dev/",
           techVisible: "display:none",
          tech: {
            tech1: "HTML",
            tech2: "CSS",
            tech3: "JavaScript"
          },
          poster: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/webPortfolio%2FFAQ%20DropDown.png?alt=media&token=5b6b6aa2-c252-4ba1-99aa-aeb969a0418b"
        },
        {
          dialog: false,
          title: "Pricing Calculator",
          git: "https://github.com/itsmidhunnair/pricing-calculator.git",
          demo: "https://pricing-calculator.pages.dev/",
          techVisible: "display:none",
          tech: {
            tech1: "HTML",
            tech2: "CSS",
            tech3: "JavaScript"
          },
          poster: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/webPortfolio%2FPricing%20Calculator.png?alt=media&token=8efba89c-055a-4771-bef6-186b464325e4"
        }
      ]
    };
  }
};
</script>

<style  scoped>
.head{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
}
</style>